import viewproduct from "./viewproduct";
import ms901 from "./ms901";
import ms902 from "./ms902";
import createproductloanreceipt from "./createproductloanreceipt";
import ms903 from "./ms903";
import ms904 from "./ms904";

export default {
    viewproduct,
    ms901,
    ms902,
    createproductloanreceipt,
    ms903,
    ms904
}